import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = '/ata-registro-preco/api/public'

class ItemAdesaoApiClient {
	async buscarItensParaAnuencia(params) {
		let url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/adesao/anuencia/${params.id}/itens`,
			pagingAndSorting: params.paginacao,
		}).build()
		return await axios.get(url)
	}
	async recusarItemAdesao(objRecusaAdesao) {
		return await axios.put(
			`${URL_PATH}/adesao/anuencia/${objRecusaAdesao.idEmailAdesaoFornec}/itens/recusar`,
			objRecusaAdesao,
		)
	}
	async aceitarItemAdesao(objAceitaAdesao) {
		return await axios
			.put(`${URL_PATH}/adesao/anuencia/${objAceitaAdesao.idEmailAdesaoFornec}/itens/aceitar`, objAceitaAdesao)
			.then(async (response) => {
				await this.gerarDocumento(objAceitaAdesao)
			})
			.catch((error) => {
				console.error('Erro na primeira solicitação:', error)
				return Promise.reject(error)
			})
			.finally(() => {
				console.log('Execução finalizada')
			})
	}

	async gerarDocumento(objAceitaAdesao) {
		return await axios
			.put(
				`${URL_PATH}/adesao/anuencia/${objAceitaAdesao.idEmailAdesaoFornec}/itens/gerarDocumento`,
				objAceitaAdesao,
			)
			.catch((error) => {
				console.error('Erro na segunda solicitação:', error)
				return Promise.reject(error)
			})
	}
}

export default new ItemAdesaoApiClient()
